module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  transformer=\"CaptainsTransforms\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  title=\"Captains\"\n  item-state=\"captain\"\n  resource=\"Captain\"\n  page=\"$ctrl.page\"\n  total=\"$ctrl.total\"\n  limit=\"$ctrl.limit\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  no-items-text=\"No Captains Yet!\"\n></list-view>\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\"></main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/captains/captains.html
// module id = 1328
// module chunks = 0